/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class PreventiveSheetTemplateCheck {
    constructor() {
        this.name = null;
        this.type = null;
        this.key = null;
        this.position = null;
        this.authorizedValues = [];
        this.authorizedValue = null;
    }
}

export {PreventiveSheetTemplateCheck};



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/PreventiveSheetTemplateCheck.js